import type { FormInputSettingsFormType } from './sp-form-input-settings.type';

import { FormControl, FormGroup } from '@angular/forms';

export const formInputSettingsForm = (): FormGroup<FormInputSettingsFormType> =>
    new FormGroup<FormInputSettingsFormType>({
        // modal styles start
        modalBackgroundColor: new FormControl(null),
        modalBorderRadius: new FormControl(null),
        modalPadding: new FormControl(null),
        modalTitleTextColor: new FormControl(null),
        modalShowLabels: new FormControl(null),
        modalInputBorderType: new FormControl(null),
        modalInputBackgroundColor: new FormControl(null),
        modalInputBorderColor: new FormControl(null),
        modalTextColor: new FormControl(null),
        modalInputTextColor: new FormControl(null),
        modalInputBorderRadius: new FormControl(null),
        modalInputSize: new FormControl(null),
        // modal styles end
        showLabels: new FormControl(null),
        inputBorderType: new FormControl(null),
        formStyleType: new FormControl(null),
        borderRadius: new FormControl(null),
        inputSize: new FormControl(null),
        horizontalPosition: new FormControl(null),
        backgroundColor: new FormControl(null),
        borderColor: new FormControl(null),
        textColor: new FormControl(null),
        inputTextColor: new FormControl(null),
        linkColor: new FormControl(null),
    });
